// extracted by mini-css-extract-plugin
export default {"changeVoteButton":"webpack-pages-StudyList-StudyListItem-components-ChangeVoteButton-module__changeVoteButton"};